import { render } from "./CwePageHeader.vue?vue&type=template&id=3ddd3ee7&scoped=true&ts=true"
import script from "./CwePageHeader.vue?vue&type=script&lang=ts"
export * from "./CwePageHeader.vue?vue&type=script&lang=ts"

import "./CwePageHeader.vue?vue&type=style&index=0&id=3ddd3ee7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddd3ee7"]])

export default __exports__